var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrap flex bg-white radius10 box-shadow submit-bar",
      class: { fixed: _vm.isFixed }
    },
    [
      _c(
        "div",
        { staticClass: "flex items-center f15 wrap" },
        [
          _c(
            "el-checkbox",
            {
              staticClass: "all-checkbox mar20-l mar35-r",
              attrs: {
                value: _vm.checked,
                disabled: _vm.checkedDisabled,
                indeterminate: _vm.indeterminate
              },
              on: { change: _vm.checkboxChange }
            },
            [
              _c("span", { staticClass: "gray3 f15 relative t2 fb" }, [
                _vm._v("全选")
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "gray9 pointer mar5-t mar10-r",
              on: { click: _vm.del }
            },
            [_vm._v("删除")]
          ),
          _c(
            "div",
            {
              staticClass: "gray9 pointer mar5-t",
              on: { click: _vm.favorite }
            },
            [_vm._v("收藏")]
          ),
          _c("div", { staticClass: "gray9 pad10-lr" }, [_vm._v("|")]),
          _c(
            "div",
            {
              staticClass: "gray9 pad35-l pointer mar5-t",
              on: { click: _vm.clearDisabled }
            },
            [_vm._v("清空全部失效商品")]
          ),
          _c("div", { staticClass: "flex-auto" }),
          _c("div", { staticClass: "mar10-r mar5-t" }, [
            _vm._v("\n      已选"),
            _c("span", { staticClass: "pad5-lr red" }, [
              _vm._v(_vm._s(_vm.total))
            ]),
            _vm._v("件商品\n    ")
          ]),
          _c("div", { staticClass: "mar20-r mar5-t" }, [
            _vm._v("\n      已优惠"),
            _c("span", { staticClass: "pad5-l red" }, [
              _vm._v("¥" + _vm._s(_vm.discountAmount))
            ])
          ]),
          _c("div", { staticClass: "mar5-r mar5-t" }, [
            _vm._v("合计（不含运费）：")
          ]),
          _c("div", { staticClass: "mar5-r red mar5-t" }, [_vm._v("¥")]),
          _c("div", { staticClass: "mar20-r f24 fb red" }, [
            _vm._v(_vm._s(_vm.amount))
          ]),
          _c(
            "div",
            {
              staticClass: "white f16 fb text-center pointer mar20-r submit",
              on: { click: _vm.cartSubmit }
            },
            [_vm._v("去结算")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }